function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Share Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M3.563,5.6255 C3.83914237,5.6255 4.063,5.84935763 4.063,6.1255 C4.063,6.40164237 3.83914237,6.6255 3.563,6.6255 L1.437,6.6255 C1.19514237,6.6255 1,6.82064237 1,7.0625 L1,15.5015 C1,15.7433576 1.19514237,15.9385 1.437,15.9385 L13.626,15.9385 C13.8672856,15.9385 14.063,15.7429298 14.063,15.5015 L14.063,7.0625 C14.063,6.82107017 13.8672856,6.6255 13.626,6.6255 L11.563,6.6255 C11.2868576,6.6255 11.063,6.40164237 11.063,6.1255 C11.063,5.84935763 11.2868576,5.6255 11.563,5.6255 L13.626,5.6255 C14.4194054,5.6255 15.063,6.26862033 15.063,7.0625 L15.063,15.5015 C15.063,16.2953797 14.4194054,16.9385 13.626,16.9385 L1.437,16.9385 C0.642857625,16.9385 -7.10542736e-15,16.2956424 -7.10542736e-15,15.5015 L-7.10542736e-15,7.0625 C-7.10542736e-15,6.26835763 0.642857625,5.6255 1.437,5.6255 L3.563,5.6255 Z M7.91511624,0.146509469 L10.7271162,2.95950947 C10.9223437,3.15480633 10.9222874,3.47138881 10.7269905,3.66661624 C10.5316937,3.86184367 10.2151112,3.86178739 10.0198838,3.66649053 L8.044,1.69 L8.06100002,10.8126023 C8.06149496,11.0887443 7.83803959,11.3130034 7.56189766,11.3135 C7.28575573,11.313995 7.06149657,11.0905396 7.06100081,10.8143977 L7.044,1.724 L5.10205339,3.66655339 C4.90679124,3.86181554 4.59020876,3.86181554 4.39494661,3.66655339 C4.19968446,3.47129124 4.19968446,3.15470876 4.39494661,2.95944661 L7.20794661,0.146446609 C7.4032333,-0.0488400829 7.71986427,-0.0488119379 7.91511624,0.146509469 Z",
  id: "share-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "share-Icon/Global/Share",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "share-Swatches/Midnight",
  transform: "translate(4.500000, 3.500000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "share-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#share-path-1"
})));

var SvgShare = function SvgShare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/share.04732170.svg";
export { ForwardRef as ReactComponent };